import { twMerge } from 'tailwind-merge'
import type { AdminMenuEmbedBackdropReach } from './useAdminMenuExpansion'

const reachClassName: Record<AdminMenuEmbedBackdropReach, string> = {
  rail: 'w-18',
  expandedRail: 'w-67',
  panel: 'w-85',
  pushedPanel: 'w-134',
}

type AdminMenuEmbedBackdropProps = {
  reach: AdminMenuEmbedBackdropReach
}

export const AdminMenuEmbedBackdrop = ({ reach }: AdminMenuEmbedBackdropProps) => (
  <div
    className={twMerge(
      'absolute inset-y-0 start-0 hidden bg-(--admin-canvas) transition-[width] duration-[340ms] ease-nav group-has-[[data-embed-page]]/admin-canvas:block motion-reduce:transition-none',
      reachClassName[reach]
    )}
  >
    <span className='pointer-events-none absolute start-full top-2 size-(--radius-2xl) rounded-ss-2xl ring-(--admin-canvas) ring-16 [clip-path:inset(0)]' />
    <span className='pointer-events-none absolute start-full bottom-2 size-(--radius-2xl) rounded-es-2xl ring-(--admin-canvas) ring-16 [clip-path:inset(0)]' />
  </div>
)
